/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { OrganizationSettingsDtoModel, OrganizationSettingsDtoModelType } from "./OrganizationSettingsDtoModel"
import { OrganizationSettingsDtoModelSelector } from "./OrganizationSettingsDtoModel.base"
import { RootStoreType } from "./index"


/**
 * OrganizationDtoBase
 * auto generated base class for the model OrganizationDtoModel.
 */
export const OrganizationDtoModelBase = ModelBase
  .named('OrganizationDto')
  .props({
    __typename: types.optional(types.literal("OrganizationDto"), "OrganizationDto"),
    id: types.identifier,
    uuid: types.union(types.undefined, types.string),
    name: types.union(types.undefined, types.string),
    address: types.union(types.undefined, types.null, types.string),
    phoneNumber: types.union(types.undefined, types.null, types.string),
    customerFacingEmail: types.union(types.undefined, types.null, types.string),
    website: types.union(types.undefined, types.null, types.string),
    logoUrl: types.union(types.undefined, types.null, types.string),
    brandColor: types.union(types.undefined, types.null, types.string),
    gclid: types.union(types.undefined, types.null, types.string),
    experiments: types.union(types.undefined, types.null, types.frozen()),
    settings: types.union(types.undefined, types.late((): any => OrganizationSettingsDtoModel)),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class OrganizationDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get uuid() { return this.__attr(`uuid`) }
  get name() { return this.__attr(`name`) }
  get address() { return this.__attr(`address`) }
  get phoneNumber() { return this.__attr(`phoneNumber`) }
  get customerFacingEmail() { return this.__attr(`customerFacingEmail`) }
  get website() { return this.__attr(`website`) }
  get logoUrl() { return this.__attr(`logoUrl`) }
  get brandColor() { return this.__attr(`brandColor`) }
  get gclid() { return this.__attr(`gclid`) }
  get experiments() { return this.__attr(`experiments`) }
  settings(builder: string | OrganizationSettingsDtoModelSelector | ((selector: OrganizationSettingsDtoModelSelector) => OrganizationSettingsDtoModelSelector) | undefined) { return this.__child(`settings`, OrganizationSettingsDtoModelSelector, builder) }
}
export function selectFromOrganizationDto() {
  return new OrganizationDtoModelSelector()
}

export const organizationDtoModelPrimitives = selectFromOrganizationDto().uuid.name.address.phoneNumber.customerFacingEmail.website.logoUrl.brandColor.gclid.experiments
